// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2ERtY","label":"LabeledBox_label__137AP"};